import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M8 5h4v1H8V5zM8 8h4v1H8V8zM8 11h4v1H8v-1zM8 14h4v1H8v-1z'],
  height: 20,
  width: 20,
});
